import api from "src/shared/api";
import { EQueryTagTypes, ISwoolResponse } from "src/shared/types/api";
import { getProvidesTags } from "src/shared/utils/url/query.helpers";
import { IFinalReportItem, IGetFinalReportsQuery } from "../model/types";

const finalReportApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFinalReportsList: build.query<
      ISwoolResponse<IFinalReportItem[]>,
      Partial<IGetFinalReportsQuery>
    >({
      query: (params) => {
        return {
          url: "api/reports/partner/bonuses/final",
          method: "GET",
          params,
        };
      },
      providesTags: (response) => {
        const tags = [{ type: EQueryTagTypes.FINAL_REPORT, id: "LIST" }];

        if (!response) {
          return tags;
        }

        tags.push(
          ...getProvidesTags<IFinalReportItem>(
            response.data,
            EQueryTagTypes.FINAL_REPORT,
          ),
        );

        return tags;
      },
    }),
    updateFinalReportNote: build.mutation<
      ISwoolResponse<IFinalReportItem>,
      { summary_reward_id: number; note: string }
    >({
      query: ({ summary_reward_id, ...body }) => {
        return {
          url: `api/reports/partner/bonuses/summary/bonus/${summary_reward_id}/update-note`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (response) => [
        { type: EQueryTagTypes.FINAL_REPORT, id: response?.data.id },
        { type: EQueryTagTypes.FINAL_REPORT, id: "LIST" },
      ],
    }),
    exportFinalReport: build.query<string, Partial<IGetFinalReportsQuery>>({
      query: (params) => {
        return {
          url: "api/reports/partner/bonuses/final/export",
          method: "GET",
          params,
          responseHandler: (response) => response.text(),
        };
      },
      transformResponse: (response: string) => response,
    }),
  }),
});

export const {
  useGetFinalReportsListQuery,
  useLazyExportFinalReportQuery,
  useUpdateFinalReportNoteMutation,
} = finalReportApi;
